<template>
    <div class="schedule-container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/Welcome' }">
                    <i class="el-icon-s-home"></i>首页
                </el-breadcrumb-item>
                <el-breadcrumb-item><i class="el-icon-date"></i>展会排期列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 主内容卡片 -->
        <el-card class="main-card" shadow="hover">
            <!-- 头部操作区域 -->
            <div class="card-header">
                <div class="header-title">
                    <i class="el-icon-s-data"></i>
                    <span>展会排期管理</span>
                </div>
                <div class="header-actions">
                    <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="addData">
                        新增排期
                    </el-button>
                    <el-button size="mini" icon="el-icon-s-grid" @click="goCategory">
                        分类管理
                    </el-button>
                </div>
            </div>

            <!-- 搜索区域 -->
            <div class="search-container">
                <el-form
                        :inline="true"
                        :model="searchForm"
                        ref="searchForRef"
                        label-width="80px"
                        size="mini"
                        class="search-form"
                >
                    <el-form-item label="展会名称">
                        <el-select
                                v-model="searchForm.exhibition_id"
                                placeholder="请选择展会"
                                clearable
                                filterable
                                style="width: 200px"
                        >
                            <el-option
                                    v-for="item in exhibitionList"
                                    :key="item.id"
                                    :label="item.title"
                                    :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="展馆名称">
                        <el-select
                                v-model="searchForm.venue_id"
                                placeholder="请选择展馆"
                                clearable
                                filterable
                                style="width: 200px"
                        >
                            <el-option
                                    v-for="item in venueList"
                                    :key="item.id"
                                    :label="item.title"
                                    :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="排期状态">
                        <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="未开始" value="0"></el-option>
                            <el-option label="进行中" value="1"></el-option>
                            <el-option label="已结束" value="2"></el-option>
                            <el-option label="已取消" value="3"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="时间范围">
                        <el-date-picker
                                v-model="searchForm.dateRange"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="timestamp"
                        >
                        </el-date-picker>
                    </el-form-item>

                    <el-form-item>
                        <el-button size="mini" type="primary" icon="el-icon-search" @click="searchSubmit">搜索</el-button>
                        <el-button size="mini" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <!-- 数据表格 -->
            <div class="table-container">
                <el-table
                        ref="multipleTable"
                        :data="tableLoadData"
                        stripe
                        border
                        size="mini"
                        v-loading="loading"
                        element-loading-text="数据加载中..."
                        element-loading-spinner="el-icon-loading"
                        :empty-text="emptyText"
                        style="width: 100%"
                >
                    <el-table-column type="index" label="序号" width="70" align="center">
                        <template slot-scope="scope">
                            <span>{{ (pageNum - 1) * pageSize + scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="展会名称"
                            width="250"
                            :show-overflow-tooltip='true'
                    >
                        <template slot-scope="scope">
                            {{ scope.row.expo.title||'' }}
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="所属展馆"
                            width="180"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.venue" class="venue-info">
                                <div class="venue-name">{{ scope.row.venue.title }}</div>
                                <div class="venue-location" v-if="scope.row.venue.address">
                                    <i class="el-icon-location"></i>
                                    {{ scope.row.venue.address }}
                                </div>
                            </div>
                            <span v-else class="empty-text">未分配</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="排期时间"
                            width="220"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <div class="schedule-time">
                                <div class="start-time">
                                    <i class="el-icon-time"></i>
                                    {{ scope.row.expo.start_time | dateFormat }}
                                </div>
                                <div class="end-time">
                                    <i class="el-icon-time"></i>
                                    {{ scope.row.expo.end_time | dateFormat }}
                                </div>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="持续时间"
                            width="120"
                            align="center"
                    >
                        <template slot-scope="scope">
              <span v-if="scope.row.expo.start_time && scope.row.expo.end_time">
                {{ calculateDuration(scope.row.expo.start_time, scope.row.expo.end_time) }}
              </span>
                            <span v-else class="empty-text">-</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="排期状态"
                            width="120"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <el-tag
                                    v-if="scope.row.status === 0"
                                    size="mini"
                                    type="info"
                                    effect="dark"
                            >未开始</el-tag>
                            <el-tag
                                    v-else-if="scope.row.status === 1"
                                    size="mini"
                                    type="success"
                                    effect="dark"
                            >进行中</el-tag>
                            <el-tag
                                    v-else-if="scope.row.status === 2"
                                    size="mini"
                                    type="warning"
                                    effect="dark"
                            >已结束</el-tag>
                            <el-tag
                                    v-else
                                    size="mini"
                                    type="danger"
                                    effect="dark"
                            >已取消</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="展位数量"
                            width="120"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <div class="booth-count">
                                <span v-if="scope.row.booth_count">总计: {{ scope.row.booth_count }}</span>
                                <span  class="empty-text">-</span>
                                <div  class="used-booths">
                                    已用: {{ scope.row.boothes.length||0 }}
                                </div>
                                <span class="empty-text">-</span>
                                <div  class="available-booths">
                                    可用: {{ scope.row.booth_count - scope.row.boothes.length}}
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="展位图"
                            width="180"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <span>
                                {{scope.row.file_url}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="添加日期"
                            width="180"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <span>{{ scope.row.add_time | dateFormat }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="操作"
                            width="180"
                            fixed="right"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <div class="action-buttons">
                                <el-button
                                        type="text"
                                        icon="el-icon-edit"
                                        size="mini"
                                        @click="handleClick(scope.row)"
                                >编辑</el-button>
                                <el-button
                                        type="text"
                                        icon="el-icon-delete"
                                        size="mini"
                                        @click="del(scope.row)"
                                >删除</el-button>
                                <el-button
                                        type="text"
                                        icon="el-icon-delete"
                                        size="mini"
                                        @click="goInfo(scope.row)"
                                >详情</el-button>
                                <el-button
                                        type="text"
                                        icon="el-icon-delete"
                                        size="mini"
                                        @click="addBooth(scope.row)"
                                >展位信息</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNum"
                        :page-sizes="[10, 20, 30, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                >
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
    import moment from 'moment'


    export default {
        name: "ScheduleList",
        components: {},
        props: {},
        data() {
            return {
                // 展会列表
                exhibitionList: [],
                // 展馆列表
                venueList: [],

                // 搜索表单
                searchForm: {
                    exhibition_id: "",
                    venue_id: "",
                    status: "",
                    dateRange: [],
                    start_time: "",
                    end_time: ""
                },
                // 表格数据
                tableLoadData: [],
                loading: false,
                emptyText: "暂无数据",

                // 分页
                pageNum: 1,
                pageSize: 10,
                total: 0,

                showType: '',
            };
        },
        created() {
            this.showType = this.$route.query.showType;
            this.DataList();
            this.getExhibitionList();
            this.getVenueList();
        },
        filters: {
            // 时间格式化
            dateFormat(add_time) {
                if (!add_time) return "";
                return moment(add_time * 1000).format("YYYY-MM-DD HH:mm");
            }
        },
        methods: {
            addBooth(row){
                this.$router.push({
                    name:'boothForm',
                    query:{
                        id:row.id
                    }
                })
            },
            // 计算持续时间
            calculateDuration(startTime, endTime) {
                if (!startTime || !endTime) return "-";

                const start = moment(startTime * 1000);
                const end = moment(endTime * 1000);
                const duration = moment.duration(end.diff(start));

                const days = duration.days();
                const hours = duration.hours();

                if (days > 0) {
                    return `${days}天${hours}小时`;
                } else {
                    return `${hours}小时`;
                }
            },

            // 获取展会列表
            getExhibitionList() {
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    pageNum: 1,
                    pageSize: 1000
                }

                this.$axios.findExpoListP(param).then(res => {
                    if (res.code == 200) {
                        this.exhibitionList = res.data.data || [];
                    }
                }).catch(error => {
                    console.log(error);
                })
            },

            // 获取展馆列表
            getVenueList() {
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    pageNum: 1,
                    pageSize: 1000
                }

                this.$axios.newsListP(param).then(res => {
                    if (res.code == 200) {
                        this.venueList = res.data.data || [];
                    }
                }).catch(error => {
                    console.log(error);
                })
            },

            // 跳转到编辑页面
            handleClick(row) {
                this.$router.push('/scheduleForm?id=' + row.id)
            },

            // 跳转到分类管理
            goCategory() {
                this.$router.push('/scheduleCategory')
            },

            // 获取展会排期列表
            DataList() {
                this.loading = true;

                // 处理时间范围
                if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
                    this.searchForm.start_time = this.searchForm.dateRange[0] / 1000;
                    this.searchForm.end_time = this.searchForm.dateRange[1] / 1000;
                } else {
                    this.searchForm.start_time = "";
                    this.searchForm.end_time = "";
                }

                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    showType: this.showType,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    parent_id: sessionStorage.getItem('shop_id'),
                    exhibition_id: this.searchForm.exhibition_id,
                    venue_id: this.searchForm.venue_id,
                    status: this.searchForm.status,
                    start_time: this.searchForm.start_time,
                    end_time: this.searchForm.end_time
                }

                // 使用展会排期列表接口
                this.$axios.findExpoScheduleListP(param).then(res => {
                    this.loading = false;
                    if (res.code == 200) {
                        this.tableLoadData = res.data.data || [];
                        this.total = res.data.total || 0;

                        // 如果没有数据，显示提示信息
                        if (this.tableLoadData.length === 0) {
                            this.emptyText = "暂无展会排期数据";
                        }
                    } else {
                        this.$message.error(res.msg || "获取数据失败");
                    }
                }).catch(error => {
                    this.loading = false;
                    console.log(error);
                    this.$message.error("网络错误，请稍后重试");
                })
            },

            // 设置每页条数
            handleSizeChange(newSize) {
                this.pageSize = newSize;
                this.pageNum = 1;
                this.DataList();
            },

            // 分页跳转
            handleCurrentChange(newPage) {
                this.pageNum = newPage;
                this.DataList();
            },
// 新增展会排期
            goInfo(row) {
                this.$router.push({
                    name:"expoScheduleInfo",
                    query:{
                        id:row.id
                    }});

            },
            // 新增展会排期
            addData() {
                this.$router.push('/expoScheduleForm');
            },

            // 搜索
            searchSubmit() {
                this.pageNum = 1;
                this.DataList();
            },

            // 重置搜索
            resetSearch() {
                this.searchForm = {
                    exhibition_id: "",
                    venue_id: "",
                    status: "",
                    dateRange: []
                };
                this.pageNum = 1;
                this.DataList();
            },

            // 删除展会排期
            del(e) {
                this.$confirm('确定要删除该展会排期吗？', '删除确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    const param = {
                        operator_id: sessionStorage.getItem('user_id'),
                        company_id: sessionStorage.getItem('company_id'),
                        access_token: sessionStorage.getItem('token'),
                        id: e.id,
                    }

                    // 使用展会排期删除接口
                    this.$axios.scheduleDel(param).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.msg);
                            this.pageNum = 1;
                            this.DataList();
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(error => {
                        console.log(error);
                        this.$message.error("删除失败，请稍后重试");
                    });
                }).catch(() => {
                    this.$message.info('已取消删除');
                });
            }
        }
    };
</script>

<style scoped>
    .schedule-container {
        padding: 20px;
        background-color: #f5f7fa;
        min-height: calc(100vh - 84px);
    }

    .breadcrumb-container {
        margin-bottom: 20px;
    }

    .main-card {
        border-radius: 8px;
        border: none;
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #ebeef5;
        margin-bottom: 20px;
    }

    .header-title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: #303133;
    }

    .header-title i {
        margin-right: 8px;
        color: #409EFF;
    }

    .search-container {
        margin-bottom: 20px;
    }

    .search-form {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .table-container {
        margin-bottom: 20px;
    }

    .exhibition-name-cell {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .exhibition-name {
        font-weight: 500;
        margin-bottom: 4px;
    }

    .exhibition-category {
        margin-top: 2px;
    }

    .venue-info {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .venue-name {
        font-weight: 500;
        margin-bottom: 4px;
    }

    .venue-location {
        font-size: 12px;
        color: #909399;
        display: flex;
        align-items: center;
    }

    .venue-location i {
        margin-right: 4px;
    }

    .schedule-time {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .start-time, .end-time {
        display: flex;
        align-items: center;
        margin: 2px 0;
        font-size: 12px;
    }

    .start-time i, .end-time i {
        margin-right: 4px;
        color: #409EFF;
    }

    .booth-count {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .available-booths {
        font-size: 12px;
        color: #67C23A;
        margin-top: 2px;
    }
    .used-booths {
        font-size: 12px;
        color: #ff0000;
        margin-top: 2px;
    }


    .empty-text {
        color: #909399;
        font-style: italic;
    }

    .action-buttons {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 8px;
    }

    .pagination-container {
        display: flex;
        justify-content: flex-end;
    }

    /* 响应式调整 */
    @media (max-width: 768px) {
        .schedule-container {
            padding: 10px;
        }

        .card-header {
            flex-direction: column;
            align-items: flex-start;
        }

        .header-actions {
            margin-top: 10px;
        }

        .search-form {
            flex-direction: column;
            align-items: flex-start;
        }

        .search-form .el-form-item {
            margin-right: 0;
            margin-bottom: 10px;
            width: 100%;
        }

        .action-buttons {
            flex-direction: column;
            gap: 5px;
        }

        .action-buttons .el-button {
            width: 100%;
        }
    }
</style>
